// 저장하지 않은 편집이 있을 때 화면 이탈(새로고침/창 닫기/라우트 이동)을 막는 공용 믹스인.
// 사용하는 컴포넌트가 boolean 인 `hasUnsavedChanges`(computed 또는 data)를 제공해야 한다.
// 라우트 컴포넌트는 beforeRouteLeave 가 자동 적용되고, 모달 등 자식은 `await this.confirmDiscardChanges()` 를 쓴다.
const DEFAULT_TITLE = '저장하지 않은 편집';
const DEFAULT_MESSAGE = '저장하지 않은 편집 내용이 있습니다. 이 화면을 벗어나면 편집 내용이 사라집니다. 나가시겠습니까?';

export default {
    created() {
        window.addEventListener('beforeunload', this.onUnsavedBeforeUnload);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.onUnsavedBeforeUnload);
    },
    beforeRouteLeave(to, from, next) {
        this.confirmDiscardChanges().then((ok) => next(ok ? undefined : false));
    },
    methods: {
        onUnsavedBeforeUnload(e) {
            // 새로고침/창 닫기 시 브라우저 기본 확인창
            if (!this.hasUnsavedChanges) return;
            e.preventDefault();
            e.returnValue = '';
        },
        // 미저장 변경이 없으면 true, 있으면 확인창 결과(true=버리고 진행)
        confirmDiscardChanges({title = DEFAULT_TITLE, message = DEFAULT_MESSAGE} = {}) {
            if (!this.hasUnsavedChanges) return Promise.resolve(true);
            return Promise.resolve(this.$showModal({type: 'confirm', state: 'warning', title, message})).then(Boolean);
        }
    }
};
